import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import ProxyIcon from 'images/homePage/proxy-icon.svg'
import DNSIcon from 'images/homePage/dns-icon.svg'
import { Svg } from 'ui'

const content = [
  {
    icon: DNSIcon,
    title: 'What is DNS?',
    description: `Think of it like Google Maps. You type in a name of a restaurant you want to go to, and it gives you the street address of the restaurant. A DNS server does the same thing, except the street address is an IP address of the website you're trying to reach.`,
  },
  {
    icon: ProxyIcon,
    title: 'What is a proxy?',
    description: `Sticking with the food analogy, instead of going to the restaurant, you can order food through an app. A person will go get the food on your behalf and bring it to you. The restaurant has no idea who you are or where you live. A proxy does exactly that, but for websites.`,
  },
]

const WhatIsDNSAndProxySection = (): ReactElement => {
  return (
    <Flex
      sx={{
        my: ['2.4rem', '3.2rem'],
        px: ['1.6rem', '4.8rem'],
        flexDirection: ['column', 'column', 'row'],
        textAlign: ['center', 'center', 'left'],
        '& > div:last-child': {
          mr: 0,
          mb: 0,
        },
      }}
    >
      {content.map(({ icon, title, description }) => (
        <Flex
          key={title}
          sx={{
            flexDirection: 'column',
            mb: ['4rem', '4.8rem', '0'],
            mr: [0, 0, '4.8rem'],
          }}
        >
          <Flex
            sx={{
              flexDirection: ['column', 'row'],
              mb: ['2.4rem', '3.2rem'],
              alignItems: 'center',
              justifyContent: ['center', 'center', 'left'],
            }}
          >
            <Svg
              svg={icon}
              sx={{
                mr: [0, '2.4rem'],
                height: ['4rem', '6.8rem'],
                width: ['4rem', '6.8rem'],
                mb: ['1.6rem', 0],
              }}
              descriptiveText={`${title} icon`}
            />
            <Text
              as="h3"
              sx={{
                fontSize: ['2.8rem', '4rem'],
                fontWeight: 'bold',
              }}
            >
              {title}
            </Text>
          </Flex>
          <Text sx={{ fontSize: ['1.8rem', '2.1rem'], color: 'aliceBlue60' }}>{description}</Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default WhatIsDNSAndProxySection
